import { ReactElement, Fragment } from 'react';

import { Box, Grid } from '@breathelife/mui';

import { RenderingField } from '@zinnia/form-engine-sdk';
import { DynamicPdfFieldProps } from '@breathelife/types';
import { PdfFieldText, ReactHtmlParser } from '@breathelife/ui-components';

import { BaseFieldProps } from '../FieldGenerator/FieldGenerator';
import { Field } from './Field';

export type DynamicPdfQuestionProps = BaseFieldProps & { fieldOptions: DynamicPdfFieldProps };

export function DynamicPdfQuestion(props: DynamicPdfQuestionProps): ReactElement | null {
  const { currency, locale, fieldGroup, fieldOptions } = props;

  return (
    <Fragment>
      {fieldGroup.title && (
        <Box mb={2} mt={-1}>
          <PdfFieldText>
            <ReactHtmlParser html={fieldGroup.title} />
          </PdfFieldText>
        </Box>
      )}

      <Grid container spacing={3} alignItems={fieldOptions.displayAll ? 'flex-start' : 'flex-end'}>
        {fieldGroup.fields.map((field: RenderingField) => (
          <Fragment key={field.id}>
            <Field currency={currency} field={field} locale={locale} fieldOptions={fieldOptions} />
          </Fragment>
        ))}
      </Grid>
    </Fragment>
  );
}
